import axios from 'axios';
import router from '../router';

const apiClient = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// 1. Interceptor للطلبات الصادرة (إضافة التوكن تلقائياً)
apiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// 2. Interceptor للردود الواردة (معالجة Refresh Token أو 401)
apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        // --- التعديل هنا: فحص وجود error.response ---
        if (!error.response) {
            console.error("Erreur de connexion au serveur (le serveur ne répond pas ou est hors service) :", error);
            // منع الانهيار وإرجاع خطأ مخصص
            return Promise.reject({
                response: { status: 503, data: { message: "Le serveur ne répond pas." } }
            });
        }
        // ------------------------------------------
        const originalRequest = error.config;

        // إذا كان الخطأ 401 (غير مصرح) والطلب لم يحاول التجديد بعد
        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                // هنا نقوم بطلب Refresh Token من الباك إند
                // ملاحظة: LexikJWT يتطلب إرسال الـ refresh_token المخزن
                const refreshToken = localStorage.getItem('refresh_token');

                const response = await axios.post(`${import.meta.env.VITE_API_BASE_URL}/token/refresh`, {
                    refresh_token: refreshToken
                });

                if (response.status === 200) {
                    const { token, refresh_token } = response.data;
                    localStorage.setItem('token', token);
                    localStorage.setItem('refresh_token', refresh_token);

                    // تحديث الطلب الأصلي بالتوكن الجديد وإعادة إرساله
                    originalRequest.headers.Authorization = `Bearer ${token}`;
                    return apiClient(originalRequest);
                }
            } catch (refreshError) {
                // إذا فشل تجديد التوكن، نسجل الخروج ونوجه للمدخل
                localStorage.clear();
                router.push('/login');
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error);
    }
);

export default apiClient;